import { render, staticRenderFns } from "./CapLivro.vue?vue&type=template&id=aa3d23cc&"
import script from "./CapLivro.vue?vue&type=script&lang=js&"
export * from "./CapLivro.vue?vue&type=script&lang=js&"
import style0 from "./CapLivro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports